// src/components/LogoutButton.tsx
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { MdExitToApp } from "react-icons/md";

import Modal from "components/Modal";
import { Button } from "components/ui";
import { navItemClass, navIconClass } from "components/sidebar/components/Links";

interface LogoutButtonProps {
  /**
   * `sidebar` renderiza un item de navegacion (se monta dentro del <ul> del
   * sidebar); `menu` renderiza una fila del menu del avatar.
   * Antes existian dos copias identicas de este componente -- una aca y otra
   * embebida en el navbar -- que se fueron desincronizando visualmente.
   */
  variant?: "sidebar" | "menu";
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ variant = "sidebar" }) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleLogout = async () => {
    try {
      // Optional: Inform backend to invalidate the token
      const token = localStorage.getItem("token");
      if (token) {
        await fetch("/api/logout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      // Perform logout
      logout();

      // Redirect to login page
      navigate("/inicio-sesion");
    } catch (error) {
      console.error("Cerrar Sesión falló:", error);
      // Optionally, display an error message to the user
    }
  };

  const confirmModal = (
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <h3 className="select-none text-[17px] font-semibold text-gray-900 dark:text-white">
        ¿Cerrar sesión?
      </h3>
      <p className="mt-2 select-none text-sm leading-relaxed text-gray-700 dark:text-gray-300">
        Podrás volver a iniciar sesión en cualquier momento.
      </p>
      <div className="mt-6 flex select-none justify-end gap-2">
        <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleLogout}>
          Cerrar sesión
        </Button>
      </div>
    </Modal>
  );

  if (variant === "menu") {
    return (
      <>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="flex w-full items-center gap-3 rounded-control px-2 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white"
        >
          <MdExitToApp className="h-[18px] w-[18px] shrink-0 text-gray-600 dark:text-gray-500" />
          Cerrar Sesión
        </button>
        {confirmModal}
      </>
    );
  }

  return (
    <li>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className={`${navItemClass(false)} w-full text-left`}
      >
        <span className={navIconClass(false)}>
          <MdExitToApp className="h-[18px] w-[18px]" />
        </span>
        <span className="truncate">Cerrar Sesión</span>
      </button>
      {confirmModal}
    </li>
  );
};

export default LogoutButton;
